// extracted by mini-css-extract-plugin
module.exports = {"folder-description":"_3VK4C","folderDescription":"_3VK4C"};